import React from "react";
import { LanguageProvider, useLanguage } from "./LanguageContext";
import Navigation from "./components/Navigation";
import Hero from "./components/Hero";
import About from "./components/About";
import Services from "./components/Services";
import WhyChoose from "./components/WhyChoose";
import Resources from "./components/Resources";
import Partners from "./components/Partners";
import Contact from "./components/Contact";
import Footer from "./components/Footer";
import "./styles.css";

const PageContent: React.FC = () => {
    const { lang } = useLanguage();
    return (
        <div className="page" dir={lang === "he" ? "rtl" : "ltr"}>
            <Navigation />
            <Hero />
            <About />
            <Services />
            <WhyChoose />
            <Resources />
            <Partners />
            <Contact />
            <Footer />
        </div>
    );
};

const App: React.FC = () => (
    <LanguageProvider>
        <PageContent />
    </LanguageProvider>
);

export default App;
